// Audioralis: open header mega/dropdown menus on hover (desktop only).
// Dawn opens them on click for accessibility; keep that, add hover intent.
(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  var HOVER_CLOSE_DELAY = 220;
  document.querySelectorAll('header-menu > details, .header__inline-menu details').forEach(function (details) {
    var timer = null;
    var summary = details.querySelector('summary');
    if (!summary) return;
    details.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
    details.addEventListener('mouseleave', function () {
      timer = setTimeout(function () {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, HOVER_CLOSE_DELAY);
    });
  });
})();
